export const PROFILE_WIZARD_STEPS = ["O meni", "Vještine", "Interesi"];
